<template>
  <Dialog
    :visible.sync="visible"
    :title="$t('login.role')"
    :confirm-text="$t('game.confirm')"
    :show-close="false"
    @close="$emit('close')"
    @touchmove.native.prevent
  >
    <div class="role_list" @touchmove.stop v-touchmove>
      <div
        class="role_item"
        :class="{ active: curRoleId === role.role_id }"
        v-for="role in roleList"
        :key="role.role_id"
        @click="curRoleId = role.role_id"
      >
        <UserInfo :showInfo="role" mode="choose_role" />
      </div>
    </div>
    <div class="agree">
      <!-- 同意相关 -->
      <div class="tips_con">
        <div
          class="checkbox"
          :class="{ active: cacheLogin }"
          @click.stop="cacheLogin = !cacheLogin"
        ></div>
        <div class="checkbox-text">{{ $t('login.seven') }}</div>
      </div>
      <div class="tips_con">
        <div class="checkbox" :class="{ active: agree }" @click.stop="agree = !agree"></div>
        <div class="checkbox-text" v-html="transformCheckTips($t('game.checkTIps1'))"></div>
      </div>
      <div class="redcolor" v-show="!agree">{{ agreeErrorMsg }}</div>
    </div>

    <template #footer>
      <div class="button" :class="!agree && curRoleId ? 'disabled' : ''" @click="updateCurrentRole">
        {{ $t('game.confirm') }}
      </div>
    </template>
  </Dialog>
</template>
<script>
import { mapState } from 'vuex'
import UserInfo from '../userCard/userInfo.vue'

export default {
  name: 'ChooseRole',
  components: {
    UserInfo,
  },
  props: {
    roleList: {
      type: Array,
    },
    roleId: {
      type: String,
    },
  },
  computed: {
    ...mapState({
      isNewWebsite: (state) => state.app.isNewWebsite,
    }),
  },
  data() {
    return {
      visible: false,
      curRoleId: this.roleId || '',
      cacheLogin: false,
      agree: false,
      agreeErrorMsg: '',
    }
  },
  created() {
    this.visible = true
    this.setRoleId()
  },
  methods: {
    setRoleId() {
      if (this.roleList.filter((item) => item.role_id === this.roleId).length > 0) {
        this.curRoleId = this.roleId
      } else {
        this.curRoleId = this.roleList[0].role_id
      }
    },
    async updateCurrentRole() {
      if (!this.agree) {
        try {
          await new Promise((resolve) => {
            this.$root.Bus.$emit('login-agree', {
              confirm: () => {
                this.agree = true
                resolve(true)
              },
              cancel: () => {
                resolve(false)
              },
            })
          })
        } catch (error) {}
      }

      if (this.agree) {
        this.agreeErrorMsg = ''
      } else {
        this.agreeErrorMsg = this.$t('game.checkTIps2')
        return
      }

      // in_game登录按钮点击打点
      this.$ta.track('vip_mall_combine', {
        operator_type: 3,
        to_type: this.$enum.LOGIN_TYPE.in_game,
        index_id: this.$ta.getDistinctId(),
        ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
      })

      this.$rum.report(
        'login_operator_type',
        {
          operator_type: 3,
          to_type: this.$enum.LOGIN_TYPE.in_game,
        },
        3
      )

      const userinfo = this.roleList.find((item) => item.role_id === this.curRoleId)
      this.$emit('chooseRole', userinfo, this.cacheLogin)
      this.$emit('close')
    },
    transformCheckTips(text) {
      const policyUrl = this.$utils.getPrivacyPolicyUrl(this.$i18n.locale)
      const serviceURl = this.$utils.getTermsOfServiceUrl(this.$i18n.locale)
      const paymentUrl = this.$utils.getPaymentTermsUrl(this.$i18n.locale)
      return text
        .replace(`:href="policyUrl"`, `target="_blank" href="${policyUrl}"`)
        .replace(`:href="serviceURl"`, `target="_blank" href="${serviceURl}"`)
        .replace(`:href="paymentURl"`, `target="_blank" href="${paymentUrl}"`)
    },
  },
}
</script>

<style lang="less" scoped>
.role_list {
  max-height: 200px;
  padding: 4px 0;
  overflow-y: auto;
  .role_item {
    padding: 12px 10px;
    border: 1px solid #c1c7cd;
    border-radius: 12px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: stretch;
    min-height: 72px;
    & + .role_item {
      margin-top: 8px;
    }
    &:hover {
      border-color: #18a856;
    }
    &.active {
      border-color: #18a856;
      &::before {
        content: '';
        position: absolute;
        top: -1px;
        right: 0;
        width: 45.5px;
        height: 22px;
        .bg-image('icon_user_selected');
        z-index: 1;
      }
    }
  }
}
.agree {
  padding-top: 12px;
  .tips_con {
    padding: 4px 0;
    color: rgba(98, 103, 107, 1);
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    .checkbox {
      width: 18px;
      height: 18px;
      margin-top: -1px;
      cursor: pointer;
      flex-shrink: 0;
      .bg-image('icon_checkbox');
      &.active {
        .bg-image('icon_checkbox_active');
      }
    }
    .checkbox-text {
      margin-left: 6px;
      ::v-deep(a) {
        color: #07c261;
        text-decoration: none;
      }
    }
  }
}
.redcolor {
  color: rgba(223, 60, 60, 1);
  font-size: 14px;
  margin-top: 4px;
  line-height: 16px;
}
.button {
  margin-top: 18px;
}
</style>
